import { ColorAliases } from '@mds/common';
import { MdsIcon } from '@mds/icons';

export const resultsData = [
  {
    key: 'currentFootprint',
    value: {
      headerTop: {
        title: 'Current Makersite footprint',
        icon: MdsIcon.CALENDAR,
        iconColor: [ColorAliases.SECONDARY]
      },
      isNumbers: true,
      headerBottom: {
        data: '897,24',
        unit: 'kg Co2 eq.'
      },
      showAsterisk: false,
      list: [
        {
          label: 'Last Updated',
          value: '33,71'
          // ,
          // unit: 'kg',
        }
      ]
    }
  },
  {
    key: 'calculatedFootprint',
    value: {
      headerTop: {
        title: 'Calculated footprint',
        icon: MdsIcon.SUM_FUNCTION,
        iconColor: [ColorAliases.SECONDARY]
      },
      isNumbers: true,
      headerBottom: {
        data: '897,24',
        unit: 'kg Co2 eq.',
        icon: null,
        pathColors: [ColorAliases.ERROR],
        tooltip: 'The impact is outdated, please recalculate results'
      },
      showAsterisk: false,
      list: [
        {
          label: 'Last Updated',
          value: '33,71'
          // ,
          // unit: 'kg',
        }
      ]
    }
  },
  {
    key: 'carbonReduction',
    value: {
      headerTop: {
        title: 'Carbon reduction',
        icon: MdsIcon.REDUCTION,
        iconColor: [ColorAliases.SECONDARY]
      },
      isNumbers: true,
      headerBottom: {
        data: '897,24',
        unit: 'kg Co2 eq.',
        icon: null,
        pathColors: [ColorAliases.ERROR],
        tooltip: 'The impact is outdated, please recalculate results'
      },
      showAsterisk: false,
      list: [
        {
          label: 'Last Updated',
          value: '33,71'
          // ,
          // unit: 'kg',
        }
      ]
    }
  }
];

export interface ProductModel {
  title: string;
  actions: Actions;
  stage: string;
  class: string;
  geo: string;
  cardType: string;
  card_type_label: string;
  created_by: CreatedBy;
  description: string;
  git_status: null;
  image: null;
  'image-default': string;
  target: string;
  message: string;
  unit: string;
  status: string;
  targetType: string;
  color: string;
  rid: string;
  nForks: number;
  is_forked: boolean;
  nThreads: number;
  nNewThreads: number;
  nExperts: number;
  process_count: number;
  nCompanies: null;
  activeAppList: any[];
  country: string;
  reportRID: null;
}

export interface Actions {
  delete: boolean;
}

export interface CreatedBy {
  rid: string;
  firstname: string;
  lastname: string;
  name: string;
  avatar: string;
  site_role: string;
  type: string;
  company: string;
}
